import React from 'react';
import FaqDetailSC from './faq-detail.styled';
import InfoBanner from '../../components/info-banner';
import ContentWrap from '../../components/content-wrap';
import FaqDetailBanner from '../../components/faq-detail-banner';
import FaqDetailContent from '../../components/faq-detail-content';

const FaqDetail = () => {
  return (
    <FaqDetailSC>
      <InfoBanner>
        <FaqDetailBanner />
      </InfoBanner>
      <ContentWrap>
        <FaqDetailContent />
      </ContentWrap>
    </FaqDetailSC>
  );
};

export default FaqDetail;
